<template>
    <div class="new-apple-module" data-aos="fade-up" :data-aos-delay="delay">
        <div class="new-module-inner">
            <div class="new-module-title">{{ title }}</div>
            <div class="new-module-desc">{{ description }}</div>
            <div class="new-btn-group">
                <router-link :to="link" class="new-btn-primary">Learn More</router-link>
            </div>
            <div class="new-module-img">
                <img :src="image" :alt="title" style="border-radius: 20px;" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppleModule',
    props: {
        title: String,
        description: String,
        link: String,
        image: String,
        delay: { type: Number, default: 0 },
    },
};
</script>

<style scoped>
.new-apple-module {
    background-color: #f5f5f7;
    border-radius: 40px;
    margin: 40px 0;
    overflow: hidden;
}

.new-module-inner {
    padding: 60px 40px;
    text-align: center;
}

.new-module-title {
    font-size: 3rem;
    font-weight: 600;
    margin-bottom: 16px;
}

.new-module-desc {
    font-size: 1.2rem;
    color: #6c757d;
    margin-bottom: 24px;
}

.new-btn-primary {
    display: inline-block;
    background-color: #0071e3;
    color: white;
    padding: 12px 28px;
    border-radius: 40px;
    text-decoration: none;
    font-weight: 500;
    transition: background 0.2s;
}

.new-btn-primary:hover {
    background-color: #005bb5;
}

.new-module-img {
    display: flex;
    justify-content: center;
}

.new-module-img img {
    max-width: 25%;
    margin-top: 40px;
}

@media (max-width: 768px) {
    .new-module-title {
        font-size: 2rem;
    }

    .new-module-inner {
        padding: 40px 20px;
    }
}
</style>